import React from 'react';
import { cn } from '../../lib/utils';
import Label from './Label';
import Reveal from './Reveal';
import ScrambleText from './ScrambleText';
import SplitText from './SplitText';

/*
 * Editorial section opener: an indexed mono label (it decodes into place) in the left column,
 * a display title (with optional *accent*) and lede on the right. `aside` renders under the label.
 */
const SectionIntro = ({ index, label, title, as = 'h2', size = 'display-lg', aside, className, children }) => (
  <div className={cn('grid gap-6 lg:grid-cols-12 lg:gap-8', className)}>
    <div className="lg:col-span-3">
      <Reveal blur={false} y={12}>
        <Label index={index}>
          <ScrambleText text={label} />
        </Label>
      </Reveal>
      {aside && <div className="mt-6 hidden lg:block">{aside}</div>}
    </div>
    <div className="lg:col-span-9">
      <SplitText as={as} text={title} className={cn(size, 'max-w-[18ch]')} />
      {children && (
        <Reveal delay={0.15} className="lede mt-6 max-w-2xl">
          {children}
        </Reveal>
      )}
    </div>
  </div>
);

export default SectionIntro;
